import { render, staticRenderFns } from "./Estoque.vue?vue&type=template&id=6c187a96&scoped=true"
import script from "./Estoque.vue?vue&type=script&lang=js"
export * from "./Estoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c187a96",
  null
  
)

export default component.exports